import React, { FC } from 'react';
import { t } from '@lingui/macro';

import { Notification } from '@rover/icons';
import { Box, Button } from '@rover/kibble/core';
import { StringSystemType } from '@rover/kibble/core/styledSystemPropTypes';

import { NOTIFICATIONS_CENTER_DROPDOWN_ID } from './constants';
import NotificationsCenterCounter from './NotificationsCenterCounter';

type Props = {
  unreadCountDisplay?: string;
  handleButtonClick: React.MouseEventHandler<HTMLButtonElement>;
  buttonRef: React.MutableRefObject<HTMLButtonElement | null>;
  implementDjangoHacks: boolean;
  display?: StringSystemType;
};

const NotificationsCenterToggleMobile: FC<Props> = ({
  unreadCountDisplay,
  handleButtonClick,
  buttonRef,
  implementDjangoHacks,
  display = ['inline-block', 'inline-block', 'none'],
}) => {
  return (
    <Box
      aria-controls={NOTIFICATIONS_CENTER_DROPDOWN_ID}
      display={display}
      position="relative"
      padding="2x"
    >
      <Button
        ref={buttonRef}
        onClick={handleButtonClick}
        variant="default"
        size="small"
        icon={Notification}
        padding="2x"
        color="text_color_navigation"
        aria-label={
          unreadCountDisplay
            ? t`Notifications Center, ${unreadCountDisplay} unread notifications`
            : t`Notifications Center, 0 unread notifications`
        }
        tabIndex={0} // Ensure the button is focusable by tab
        data-testid="notifications-center-toggle-mobile"
      />
      {unreadCountDisplay && (
        <NotificationsCenterCounter
          unreadCountDisplay={unreadCountDisplay}
          implementDjangoHacks={implementDjangoHacks}
          dataTestId="notifications-center-counter-mobile"
        />
      )}
    </Box>
  );
};

export default NotificationsCenterToggleMobile;
